<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/aicdPd/tc-custom/9781504059121.jpg?1721442278484" alt="This image is the cover for the book Autopsy of an Unwinnable War: Vietnam"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Autopsy of an Unwinnable War: Vietnam
      </h1>
      <p class="bookDescription body article font2">
        <b>A military studies professor and former combatant “rationally dissects the strategies and mindsets on both sides” of this thirty-year conflict (<i>New York Journal of Books</i>).</b><br/>  <br/> Since the fall of Saigon in 1975, there have been much discussion of why (and whether) America lost the war in Vietnam. The common belief is that the war was lost not on the battlefield but in Washington, DC. The stark facts, though, are that the Vietnam War was lost before the first American shot was fired. In fact, it was lost before the first French Expeditionary Corps shot, almost two decades earlier, and was finally lost when the South Vietnamese fought partly, then entirely, on their own.<br/>  <br/> Offering an informed narrative of the entire thirty-year war, this book seeks to explain why. Written by a combatant in six large battles and many smaller firefights who was also a leader with a full range of pacification duties, a commander who lost forty-three wonderful young men, <i>Autopsy of an Unwinnable War</i> is the result of a quest for answers by one who, after decades of wondering what it was all about, turned to a years-long search of French, American, and Vietnamese sources.<br/>  <br/> This is a story lived and revealed mainly by the people inside Vietnam who were directly involved in the war, from leaders in high positions down to the jungle boots and sandals level of the fighters—and among the Vietnamese who were living it. Because of what was happening inside Vietnam itself, no matter what policies and directives came out of Paris or Washington, or the influences in Moscow or Beijing, it is about a Vietnamese idea that would eventually triumph over bullets.<br/>  <br/><i>Includes photographs</i><br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        William C. Haponski, Jerry J. Burcham, Dave R. Palmer
      </h2>
      
      <p class="authorDescription body article">William C. Haponski is a 1956 graduate of West Point, commissioned in the armor branch. He served in a tank battalion in Europe during the Cold War. In 1967 he received a doctorate in English language and literature from Cornell University while also teaching full-time at West Point.&#160;Arriving in Vietnam in 1968 as a lieutenant colonel, he first was the senior staff officer in 11th Armored Cavalry Regiment, then served as commander of the Task Force 1st Squadron, 4th Cavalry, 1st Infantry Division. The task force was engaged in everything from pacification to contacts with small enemy units to fierce day-and-night battles against battalions and a regiment. Down in the jungle, night and day, he directed the battles in close combat along with his men. After Vietnam he returned to West Point and became Professor of Military Studies, first at University of Vermont, then at Fordham University. After retiring from the Army, he held further academic positions and wrote several books.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Casemate Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1dab4e34